import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import Icon from "@irati/ui/src/Icon"

interface Props {
  isSelected?: boolean
}
interface StyledCardProps extends Props {
  hideSelector: boolean
}

export const PopularWrapper = styled.div`
  position: absolute;
  width: 91px;
  height: 70px;
  right: 0;
  top: 0;
  overflow: hidden;
`

export const Popular = styled.div`
  width: 115px;
  height: 39px;
  background: linear-gradient(96deg, #65e7e2 16.05%, #41ff6b 98.9%);
  transform: rotate(37deg);
`

export const StyledCard = styled(Card)<StyledCardProps>`
  ${({hideSelector}) => !hideSelector && "cursor: pointer;"}
  ${({theme, isSelected}) => `border: 3px solid ${isSelected ? theme.colors.secondary1 : theme.colors.primary2};`}
  position: relative;
  min-width: 305px;
  flex-shrink: 0;
`

export const OuterCircle = styled.div<Props>`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  margin-right: ${({theme}) => theme.spacing.one};
  ${({theme, isSelected}) =>
    isSelected
      ? `
    background: ${theme.colors.secondary1};
    `
      : `
    border: 1px solid ${theme.colors.primary2};
    `}
`

export const RelativeIcon = styled(Icon)`
  position: relative;
  top: 5px;
  left: 4px;
`

export const RedStrikethrough = styled.span`
  color: ${({theme}) => theme.colors.tertiary.r_400};
  text-decoration: line-through;
`

export const StyledIcon = styled(Icon)`
  position: relative;
  left: 2px;
  path:last-child {
    fill: ${({theme}) => theme.colors.greys.white};
  }
`

export const AnnualSaving = styled(Card)`
  max-height: 24px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  .loader {
    left: 42%;
  }
`
